
export default {
  TICKET_STUDENT_LIST: '/api/v3/customer/ticket/student/list',                       // 学生工单列表(学生端)
  TICKET_STUDENT_ADD: '/api/v3/customer/ticket/student/add',                      // 学生工单发起(学生端)
  TICKET_STUDENT_DETAIL: '/api/v3/customer/ticket/student/detail',                       // 获取学生工单详情(学生端)
  TICKET_STUDENT_CLOSE: '/api/v3/customer/ticket/student/close',                       // 关闭学生工单(学生端)
  TICKET_STUDENT_UNM: '/api/v3/customer/ticket/student/unReadCountAll',                       // 学生工单总未读消息数查询(学生端)
  TICKET_STUDENT_QUESTION_CONFIG: '/api/v3/customer/ticket/student/question/config',                       // 问题类型配置查询(学生端)
  TICKET_STUDENT_JUDGE: '/api/v3/customer/ticket/student/judge',                       // 学生工单评价(学生端)
  TICKET_STUDENT_SEND: '/api/v3/customer/ticket/student/chat/send',                      // 学生工单聊天发送(学生端)
  TICKET_STUDENT_FEIL_UPLOAD: '/api/v3/common/file/stu/public/upload'                      // 工单文件上传
}



// WEBPACK FOOTER //
// ./src/assets/api/constant/workorder.js